import type { GrantRole, UserGrant } from '../types/user.js';

export type GrantPayload = { tagId: string; role: GrantRole };

// The users API runs a strict nested pipe: a `tagName` inside a grant is a 400, so every
// request body is built here and nowhere else.
export function toGrantPayload(rows: readonly UserGrant[]): GrantPayload[] {
  return rows.map(({ tagId, role }) => ({ tagId, role }));
}

const grantKey = (grant: Pick<UserGrant, 'tagId' | 'role'>) => `${grant.tagId}:${grant.role}`;

export function grantsEqual(
  a: readonly Pick<UserGrant, 'tagId' | 'role'>[],
  b: readonly Pick<UserGrant, 'tagId' | 'role'>[],
): boolean {
  if (a.length !== b.length) return false;
  const keysOfB = new Set(b.map(grantKey));
  return a.every((grant) => keysOfB.has(grantKey(grant)));
}
